module.exports = __webpack_public_path__ + "media/waves4.fa609e2a.ogg";